import { userValidate } from "../../application/dtos/user_validate";

export class userEntity {
    constructor({id}){
        this.id = id;  
    }

    isValid() {
        return userValidate(this);
    }
}